import { css } from 'styled-components';

export const H1 = css`
  font-family: 'NotoKrBlack', 'RobotoB';
  font-size: 32px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const H2 = css`
  font-family: 'NotoKrB', 'RobotoB';
  font-size: 24px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const H3 = css`
  font-family: 'NotoKrB', 'RobotoB';
  font-size: 20px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const H4 = css`
  font-family: 'NotoKrB', 'RobotoB';
  font-size: 16px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const P1 = css`
  font-family: 'NotoKrR', 'RobotoR';
  font-size: 20px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const P2 = css`
  font-family: 'NotoKrR', 'RobotoR';
  font-size: 16px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const P3 = css`
  font-family: 'NotoKrR', 'RobotoR';
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const P4 = css`
  font-family: 'NotoKrR', 'RobotoR';
  font-size: 12px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const P5 = css`
  font-family: 'NotoKrR', 'RobotoR';
  font-size: 10px;
  color: ${(props) => props.theme.colors.grey800};
`;

export const DateErrorTypo = css`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 14px;
  color: ${(props) => props.theme.colors.grey800};
`;
